import React from 'react';

const Loader = () => {
  return (
    <div id="ftco-loader" className="show">
      <div className="spinner"></div>
    </div>
  );
};

export default Loader;
